import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import {
    SESSION_DURATION_25_MINS,
    SESSION_DURATION_50_MINS,
    SESSION_DURATION_75_MINS,
} from '@app/core/_models'
import { TIMESLOT_HEIGHT } from '../calendar-day/calendar-day.component'

// Define the interface for the session-related dimensions
interface SessionOutlineDimensions {
    outlineheight: number
}

@Component({
    selector: 'fm-session-selector-outline',
    imports: [CommonModule],
    templateUrl: './session-selector-outline.component.html',
    styleUrl: './session-selector-outline.component.scss',
})
export class SessionSelectorOutlineComponent {
    @Input() width: number = 0
    @Input() sessionDuration: number = SESSION_DURATION_25_MINS
    @Input() slotNumber: number | null = null
    @Input() sessionTime: number | null = null
    @Input() partnerAvailable: boolean = false
    @Output() timeslotselected = new EventEmitter<number>()

    public outlineHeight: number = 0

    private sessionDimensionsMap: { [key: number]: SessionOutlineDimensions } = {
        [SESSION_DURATION_25_MINS]: {
            outlineheight: TIMESLOT_HEIGHT * 2,
        },
        [SESSION_DURATION_50_MINS]: {
            outlineheight: TIMESLOT_HEIGHT * 4,
        },
        [SESSION_DURATION_75_MINS]: {
            outlineheight: TIMESLOT_HEIGHT * 6,
        },
    }

    constructor() {}

    ngOnChanges() {
        if (this.sessionDuration) {
            if (this.sessionDuration === SESSION_DURATION_75_MINS && this.slotNumber > 93) {
                this.outlineHeight =
                    this.sessionDimensionsMap[SESSION_DURATION_50_MINS].outlineheight
            } else {
                this.outlineHeight = this.sessionDimensionsMap[this.sessionDuration].outlineheight
            }
        }
    }
}
